
// Survey.tsx
import React, { FC, useContext, useEffect, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import { SurveyContext } from './SurveyContext';
import { Header } from './Header';
import { Content } from './Content';
import { Footer } from './Footer';
import {ThankYou } from './ThankYou'
import { toast } from "react-toastify";
import { 
  SurveyComponents, 
  FormDataItem,
  Answer, 
  BrandTheme,
  QuestThemeData,
  SurveyProps
} from './types';

import "../components/Feedback.css";
import "react-toastify/dist/ReactToastify.css";
import { DEFAULT_BRAND_THEME, DEFAULT_QUEST_THEME } from "../../tutorial/components/tutorial.types";
import General, { useGeneral } from "../../../../general";
import { useThemeManager } from "../components/useThemeManager";
import { fetchData, returnAnswers } from "../components/apiFunction";
import config from "../../../../config";
import { validateSection } from "../components/validateSection";
import "../components/Feedback.css";
import '../../../../components/Modules/css/input.css';
import '../../feedbackWorkflow/modular/FeedbackOverview.css'
import Loader from "../../login/components/Loader";

const Survey: FC<SurveyProps> & SurveyComponents = ({
  userId,
  token,
  questId: campaignId,
  bgColor,
  onSubmit,
  ratingType = "number",
  iconColor = "#939393",
  uniqueEmailId,
  uniqueUserId,
  styleConfig = {},
  sections,
  variation,
  design = [],
  entityAuthenticationToken,
  Headers,
  singleChoiceModal,
  multiChoiceModal,
  className,
  onCancel,
  children,
  customThanksPopup,
  showCancelButton,
  submitButtonText,
  thankYouHeading,
  thankYouDescription,
  customLoader
}) => {
  const [showLoader, setShowLoader] = useState(true);
  const [thanksPopup, setThanksPopup] = useState<boolean>(false);
  const [questData, setQuestData] = useState<any>();
  const [formdata, setFormdata] = useState<FormDataItem[]>([]);
  const [answer, setAnswer] = useState<Answer>({});
  const [selectedOptions, setSelectedOptions] = useState<Record<string, Array<string>>>({});
  const [currentSection, setCurrentSection] = useState(0);
  const [goToNextSection, setGoToNextSection] = useState(false);
  const [sectionQuestions, setSectionQuestions] = useState<FormDataItem[]>([]);
  const [questThemeData, setQuestThemeData] = useState<QuestThemeData>(DEFAULT_QUEST_THEME);
  const [BrandTheme, setBrandTheme] = useState<BrandTheme>(DEFAULT_BRAND_THEME);
  const [uiProps, setUiProps] = useState<any>({});
  const [headings, setHeadings] = useState<any>(Headers);
  const [showFooter, setShowFooter] = useState(true);
  const [designApi, setDesignApi] = useState(design || []);

  const { apiKey, apiSecret, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );

  const general = useGeneral('quest')

  const GeneralFunctions = new General("mixpanel", apiType);
  const themeManager = useThemeManager(
    BrandTheme,
    styleConfig,
    themeConfig,
    questThemeData,
  );

  const handleRatingChange = (id: string, newRating: number) => {
    setAnswer(prev => ({
      ...prev,
      [id]: String(newRating),
    }));
  };

  const handleUpdate = (e: any, id: string, j: string) => {
    if (j) {
      setAnswer(prev => ({
        ...prev,
        [id]: j,
      }));
    } else {
      setAnswer(prev => ({
        ...prev,
        [id]: e.target.value,
      }));
    }
  };

  const handleCheckboxChange = (option: string, actionId: string): void => {
    setSelectedOptions(prev => {
      const currentOptions = prev[actionId] || [];
      if (currentOptions.includes(option)) {
        return {
          ...prev,
          [actionId]: currentOptions.filter(e => e !== option),
        };
      } else {
        return {
          ...prev,
          [actionId]: [...currentOptions, option],
        };
      }
    });
  };

  const handleRadioChange = (option: string, actionId: string, j: string) => {
    if (j === "radio") {
      setAnswer(prev => ({
        ...prev,
        [actionId]: prev[actionId]?.includes(option) ? [] : [option],
      }));
    } else {
      setAnswer(prev => ({
        ...prev,
        [actionId]: option,
      }));
    }
  };

  const handleReturnAnswers = () => {
    returnAnswers({
      BACKEND_URL:
        apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL,
      entityId,
      campaignId: campaignId || "",
      formdata,
      answer,
      selectedOptions,
      questData,
      setThanksPopup,
      onSubmit,
      GeneralFunctions: new General("mixpanel", apiType),
      apiKey,
      apiSecret: apiSecret || "",
      userId: userId || "",
      token: token || "",
      uniqueUserId: uniqueUserId || "",
      toast,
    });
  };

  const handleThanks = () => {
    setThanksPopup(false);
    onCancel?.();
  };

  const divideQuestionInSection = (formdata: FormDataItem[]) => {
    let questionsDataArray: FormDataItem[] = [];
    if (designApi[currentSection]) {
      designApi[currentSection].forEach((questioNo: any) => {
        const questionData = formdata[questioNo - 1];
        if (questionData) {
          questionsDataArray.push(questionData);
        }
      });
    }
    return questionsDataArray;
  };

  useEffect(() => {
    general.trackEvent(
      'quest-survey-loaded',
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    )
    fetchData({
      BACKEND_URL:
        apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL,
      entityId,
      campaignId: campaignId || "",
      variation: variation || "",
      apiKey,
      apiSecret: apiSecret || "",
      userId: userId || "",
      token: token || "",
      setQuestData,
      setUiProps,
      setBrandTheme,
      setQuestThemeData,
      setFormdata,
      // setData,
      bgColor: bgColor || "",
      uniqueUserId: uniqueUserId || "",
      uniqueEmailId: uniqueEmailId || "",
      entityAuthenticationToken: entityAuthenticationToken || "",
      apiType,
      GeneralFunctions: new General("mixpanel", apiType),
      // setGradient,
      headings,
      setHeadings,
      setShowFooter,
      setDesignApi,
      setShowLoader,
    });
  }, []);


  useEffect(() => {
    if (
      designApi?.length > 0 &&
      formdata.length > 0 &&
      currentSection >= 0 &&
      designApi[currentSection]?.length > 0
    ) {
      const sectionQuestions = divideQuestionInSection(formdata);
      setSectionQuestions(sectionQuestions);
    }
  }, [designApi, formdata, currentSection]);

  useEffect(() => {
    validateSection(
      currentSection,
      designApi,
      formdata,
      answer,
      selectedOptions,
      setGoToNextSection
    );
  }, [answer, currentSection, selectedOptions, formdata]);

  const contextValue = {
    answer,
    setAnswer,
    selectedOptions,
    setSelectedOptions,
    currentSection,
    setCurrentSection,
    goToNextSection,
    setGoToNextSection,
    thanksPopup,
    setThanksPopup,
    formdata,
    design: designApi,
    sectionQuestions,
    themeManager,
    GeneralFunctions,
    handleReturnAnswers,
    handleThanks,
    handleUpdate,
    handleRadioChange,
    handleRatingChange,
    handleCheckboxChange,
    ratingType,
    sections,
    iconColor,
    showFooter,
    Headers: headings,
    questThemeData,
    onCancel,
    showCancelButton,
    submitButtonText,
    thankYouHeading,
    thankYouDescription,
    userId,
    uniqueUserId,
    token,
    singleChoiceModal,
    multiChoiceModal,
  };

  if (showLoader) return customLoader || <Loader />;
  if (!formdata.length || !designApi.length) return null;

  const footer = React.Children.toArray(children).find(
    child => React.isValidElement(child) && child.type === Survey.Footer && showFooter
  );

  const otherChildren = React.Children.toArray(children).filter(
    child => React.isValidElement(child) && child.type !== Survey.Footer
  );

  return (
    <SurveyContext.Provider value={contextValue}>
      <div 
        className={`q-feedback-cont ${className || ''}`}
        style={themeManager.getFormStyles()}
      >
        {thanksPopup ? (
          customThanksPopup ? (
            customThanksPopup
          ) : (
            <Survey.ThankYou>{footer}</Survey.ThankYou>
          )
        ) : (
          <>
            {otherChildren}
            {footer}
          </>
        )}
      </div>
    </SurveyContext.Provider>
  );
};

Survey.Header = Header;
Survey.Content = Content;
Survey.Footer = Footer;
Survey.ThankYou = ThankYou;

export default Survey;
